import clsx from 'clsx';
import Image from 'next/image';
import Link from 'next/link';

import {Container} from '@/modules/foundation/components/container';
import type {KeyedArray} from '@/modules/foundation/shared/types';

import logoImage from '../../../public/images/logo-light.png';

import {DesktopNav} from './DesktopNav';
import type {DropdownType} from './Dropdown';
import {MobileNav} from './MobileNav';
import type {NavLinkType} from './NavLink';

export type NavigationType = KeyedArray<NavLinkType | DropdownType>;

type NavbarProps = {
	navigation: NavigationType;
};

const FRONT_PAGE = 'Forside';

export const Navbar = ({navigation}: NavbarProps) => {
	return (
		<Container
			as="header"
			className={clsx('relative', 'z-50', 'bg-dypgronn-industri', 'text-gray-100')}
		>
			<div className={clsx('flex', 'h-24', 'items-center', 'justify-between', 'gap-4')}>
				<Link href="/">
					<Image
						src={logoImage}
						alt=""
						sizes="197px"
						quality={100}
						style={{
							width: '100%',
							height: 'auto',
						}}
					/>
					<span className={clsx('sr-only')}>{FRONT_PAGE}</span>
				</Link>
				{navigation ? (
					<>
						<DesktopNav navigation={navigation} />
						<MobileNav navigation={navigation} />
					</>
				) : null}
			</div>
		</Container>
	);
};
